import { Link } from 'react-router-dom';
import LegalPage from './LegalPage';
import { SUPPORT_EMAIL } from '../utils/constants';

const Terms = () => {
  return (
    <LegalPage title="Terms of Service" updated="June 12, 2026">
      <p>
        These are the terms for buying and using Solidly Meet, the desktop app sold by
        Solidly on this website (meet.solidly.ai). They're written to be read, not to scare
        you — if anything is unclear, email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>

      <h2>The purchase</h2>
      <ul>
        <li>
          Solidly Meet is a one-time purchase. You pay once and own your license for life,
          including all future updates. There is no subscription of any kind — not required,
          not offered.
        </li>
        <li>Payment is processed by Stripe. Prices are shown in USD at checkout.</li>
      </ul>

      <h2>Your license</h2>
      <ul>
        <li>
          Your license is personal to you and can be activated on up to 3 devices. Need more?
          Email us.
        </li>
        <li>
          Don't resell, share, or redistribute your license key or the app itself. That's the
          whole list of restrictions.
        </li>
      </ul>

      <h2>Your providers, your keys</h2>
      <ul>
        <li>
          The app runs on your own Claude subscription (via Claude Code) and your own
          AssemblyAI API key, and any notes delivery runs through MCP servers you configure
          with your own accounts. You're responsible for those accounts, their costs, and
          complying with their terms.
        </li>
        <li>
          Solidly doesn't resell or mark up your providers, and isn't responsible for their
          availability, pricing, or output.
        </li>
      </ul>

      <h2>Recording laws</h2>
      <p>
        Solidly Meet captures audio on your machine. Consent rules for recording conversations
        vary by region — it's your responsibility to comply with the laws that apply to your
        calls and to get consent where required.
      </p>

      <h2>Refunds</h2>
      <p>
        7-day money-back guarantee: if the app isn't for you, email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> within 7 days of purchase and
        we'll refund you in full — no forms, no questions.
      </p>

      <h2>The honest disclaimer</h2>
      <p>
        The app is provided "as is." We work hard to keep it reliable, but we can't guarantee
        it will be uninterrupted or error-free, and AI output — transcripts, speaker labels,
        summaries, suggested talking points — should always be reviewed before you rely on it.
        To the maximum extent permitted by law, Solidly's total liability for any claim related
        to the app is limited to the amount you paid for it.
      </p>

      <h2>Changes</h2>
      <p>
        If we update these terms, we'll update the date at the top of this page. Material
        changes won't take away anything you've already bought.
      </p>

      <p>
        See also: <Link to="/privacy">Privacy Policy</Link>. Questions go to{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>
    </LegalPage>
  );
};

export default Terms;
